export const TradingIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="52" height="52" rx="26" fill="#212939" />
      <path
        d="M18 40.09C17.7348 40.09 17.4804 39.9846 17.2929 39.7971C17.1054 39.6096 17 39.3552 17 39.09V18.09C17 17.8248 17.1054 17.5704 17.2929 17.3829C17.4804 17.1954 17.7348 17.09 18 17.09C18.2652 17.09 18.5196 17.1954 18.7071 17.3829C18.8946 17.5704 19 17.8248 19 18.09V39.09C19 39.3552 18.8946 39.6096 18.7071 39.7971C18.5196 39.9846 18.2652 40.09 18 40.09ZM26 37.09C25.7348 37.09 25.4804 36.9846 25.2929 36.7971C25.1054 36.6096 25 36.3552 25 36.09V13.09C25 12.8248 25.1054 12.5704 25.2929 12.3829C25.4804 12.1954 25.7348 12.09 26 12.09C26.2652 12.09 26.5196 12.1954 26.7071 12.3829C26.8946 12.5704 27 12.8248 27 13.09V36.09C27 36.3552 26.8946 36.6096 26.7071 36.7971C26.5196 36.9846 26.2652 37.09 26 37.09ZM34 30.09C33.7348 30.09 33.4804 29.9846 33.2929 29.7971C33.1054 29.6096 33 29.3552 33 29.09V15.09C33 14.8248 33.1054 14.5704 33.2929 14.3829C33.4804 14.1954 33.7348 14.09 34 14.09C34.2652 14.09 34.5196 14.1954 34.7071 14.3829C34.8946 14.5704 35 14.8248 35 15.09V29.09C35 29.3552 34.8946 29.6096 34.7071 29.7971C34.5196 29.9846 34.2652 30.09 34 30.09Z"
        fill="#495568"
      />
      <path
        d="M19 24.09H17C16.4477 24.09 16 24.5377 16 25.09V36.09C16 36.6423 16.4477 37.09 17 37.09H19C19.5523 37.09 20 36.6423 20 36.09V25.09C20 24.5377 19.5523 24.09 19 24.09Z"
        fill="#7CFF6B"
      />
      <path
        d="M27 17.09H25C24.4477 17.09 24 17.5377 24 18.09V23.09C24 23.6423 24.4477 24.09 25 24.09H27C27.5523 24.09 28 23.6423 28 23.09V18.09C28 17.5377 27.5523 17.09 27 17.09Z"
        fill="#FF3838"
      />
      <path
        d="M35 23.09H33C32.4477 23.09 32 23.5377 32 24.09V25.09C32 25.6423 32.4477 26.09 33 26.09H35C35.5523 26.09 36 25.6423 36 25.09V24.09C36 23.5377 35.5523 23.09 35 23.09Z"
        fill="#FF3838"
      />
    </svg>
  )
}
